import { defaultTheme, siq2Theme, ThemeI } from '../themes'

type ThemesType = { [key in Themes]: ThemeI }

export enum Themes {
  Default = 'default',
  Siq2 = 'siq2',
}

const themes: ThemesType = {
  [Themes.Default]: defaultTheme,
  [Themes.Siq2]: siq2Theme,
}

const getThemeByEnum = (theme: Themes): ThemeI => themes[theme] || defaultTheme

export default getThemeByEnum
